import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore not typed yet
import ToolbarsContainer from 'InpageEditorUI/containers/ToolbarsContainer';
import HoverOverlayContainer from 'InpageEditorUI/containers/HoverOverlayContainer';
import { getHasAnyGridLayouts, getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
// @ts-ignore not typed yet
import { layoutSectionHoverPositionsCleared } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { getBodyOffset } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
// @ts-ignore not typed yet
import TemporaryOverlaysContainer from './TemporaryOverlaysContainer';
import { useContext, useEffect } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
// @ts-ignore not typed yet
import LayoutSectionDragLayerContainer from './layoutSection/LayoutSectionDragLayerContainer';
// @ts-ignore not typed yet
import LayoutSectionDropTargetsContainer from './layoutSection/LayoutSectionDropTargetsContainer';
// @ts-ignore not typed yet
import LayoutSectionResizeHandleContainer from './layoutSection/LayoutSectionResizeHandleContainer';
// @ts-ignore not typed yet
import LayoutSectionDragDomManipulationContainer from './layoutSection/LayoutSectionDragDomManipulationContainer';
// @ts-ignore not typed yet
import LayoutSectionCustomDragLayer from '../components/LayoutSectionCustomDragLayer';
// @ts-ignore not typed yet
import LayoutSectionGridContainer from './layoutSection/LayoutSectionGridContainer';
// @ts-ignore not typed yet
import LayoutSectionSelectedNodeContainer from './layoutSection/LayoutSectionSelectedNodeContainer';
// @ts-ignore not typed yet
import LayoutSectionNopeZoneContainer from './layoutSection/LayoutSectionNopeZoneContainer';
// @ts-ignore not typed yet
import { getFeatureFlag } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { Z_INDEX_MAX_LAYERS } from 'layout-dnd-utils/constants/dnd';
import { DragPreviewProvider } from 'layout-dnd-utils/DragPreview/DragPreviewContext';
import GridLayoutSelectedNodeContainer from './layoutSection/GridLayoutSelectedNodeContainer';
import PegboardDndContainer from './gridLayout/PegboardDndContainer';
import TransitionStylesProvider from 'layout-dnd-utils/TransitionStyles/TransitionStylesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function GridLayoutUnifiedOverlaysAndToolbarsContainer({
  bus,
  bodyOffsetStyle,
  shouldUseNopeZonesForAllModules,
  children
}) {
  var _bodyOffsetStyle$top, _bodyOffsetStyle$left, _bodyOffsetStyle$top2, _bodyOffsetStyle$left2;
  const gridLayoutsBodyOffsetStyleForGridLinesDragPreviews = {
    position: 'absolute',
    top: -((_bodyOffsetStyle$top = bodyOffsetStyle === null || bodyOffsetStyle === void 0 ? void 0 : bodyOffsetStyle.top) !== null && _bodyOffsetStyle$top !== void 0 ? _bodyOffsetStyle$top : 0),
    left: -((_bodyOffsetStyle$left = bodyOffsetStyle === null || bodyOffsetStyle === void 0 ? void 0 : bodyOffsetStyle.left) !== null && _bodyOffsetStyle$left !== void 0 ? _bodyOffsetStyle$left : 0),
    zIndex: Z_INDEX_MAX_LAYERS.LEVEL_1
  };
  const gridLayoutsBodyOffsetStyle = {
    position: 'absolute',
    top: -((_bodyOffsetStyle$top2 = bodyOffsetStyle === null || bodyOffsetStyle === void 0 ? void 0 : bodyOffsetStyle.top) !== null && _bodyOffsetStyle$top2 !== void 0 ? _bodyOffsetStyle$top2 : 0),
    left: -((_bodyOffsetStyle$left2 = bodyOffsetStyle === null || bodyOffsetStyle === void 0 ? void 0 : bodyOffsetStyle.left) !== null && _bodyOffsetStyle$left2 !== void 0 ? _bodyOffsetStyle$left2 : 0),
    zIndex: Z_INDEX_MAX_LAYERS.LEVEL_3
  };
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: `${NAMESPACE_CLASS}`,
      children: /*#__PURE__*/_jsx(DragPreviewProvider, {
        dragPreviewZIndex: Z_INDEX_MAX_LAYERS.LEVEL_2.toString(),
        children: /*#__PURE__*/_jsxs(TransitionStylesProvider, {
          children: [/*#__PURE__*/_jsxs("div", {
            style: gridLayoutsBodyOffsetStyleForGridLinesDragPreviews,
            children: [/*#__PURE__*/_jsx(LayoutSectionDropTargetsContainer, {}), /*#__PURE__*/_jsx(LayoutSectionGridContainer, {}), /*#__PURE__*/_jsx(PegboardDndContainer, {})]
          }), /*#__PURE__*/_jsxs("div", {
            style: gridLayoutsBodyOffsetStyle,
            children: [/*#__PURE__*/_jsx(ToolbarsContainer, {
              bus: bus
            }), /*#__PURE__*/_jsx(HoverOverlayContainer, {}), /*#__PURE__*/_jsx(TemporaryOverlaysContainer, {}), /*#__PURE__*/_jsx(LayoutSectionDragLayerContainer, {
              dispatchActionToEventBus: bus.dispatchActionToEventBus
            }), /*#__PURE__*/_jsx(LayoutSectionResizeHandleContainer, {}), /*#__PURE__*/_jsx(LayoutSectionDragDomManipulationContainer, {}), /*#__PURE__*/_jsx(LayoutSectionCustomDragLayer, {}), /*#__PURE__*/_jsx(LayoutSectionSelectedNodeContainer, {}), /*#__PURE__*/_jsx(GridLayoutSelectedNodeContainer, {}), !shouldUseNopeZonesForAllModules && /*#__PURE__*/_jsx(LayoutSectionNopeZoneContainer, {}), children]
          })]
        })
      })
    })
  );
}
function UnifiedOverlaysAndToolbarsContainer({
  bus,
  children
}) {
  const hasAnyLayoutSections = useSelector(getHasAnyLayoutSections);
  const bodyOffset = useSelector(getBodyOffset);
  const hasAnyGridLayouts = useSelector(getHasAnyGridLayouts);
  const shouldUseNopeZonesForAllModules = getFeatureFlag(FEATURE_FLAGS.shouldUseNopeZonesForAllModules);
  const {
    tour
  } = useContext(TourContext);
  const dispatch = useDispatch();
  useEffect(() => {
    const handleHoverOutOfInpage = () => {
      const currentStep = tour ? tour.getStep() : '';
      if (currentStep !== 'resizeColumn' && currentStep !== 'sectionDropdown') {
        dispatch(layoutSectionHoverPositionsCleared());
      }
    };
    if (hasAnyLayoutSections) {
      bus.on('post:hoverOutOfInpage', handleHoverOutOfInpage);
    }
    return () => {
      if (hasAnyLayoutSections) {
        bus.off('post:hoverOutOfInpage', handleHoverOutOfInpage);
      }
    };
  }, [hasAnyLayoutSections, bus, tour, dispatch]);
  const bodyOffsetStyle = {
    position: 'absolute',
    top: -bodyOffset.top,
    left: -bodyOffset.left,
    zIndex: Z_INDEX_MAX_LAYERS.LEVEL_1
  };
  if (hasAnyGridLayouts) {
    return /*#__PURE__*/_jsx(GridLayoutUnifiedOverlaysAndToolbarsContainer, {
      bus: bus,
      bodyOffsetStyle: bodyOffsetStyle,
      shouldUseNopeZonesForAllModules: shouldUseNopeZonesForAllModules,
      children: children
    });
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs("div", {
      className: `${NAMESPACE_CLASS}`,
      style: bodyOffsetStyle,
      children: [/*#__PURE__*/_jsx(ToolbarsContainer, {
        bus: bus
      }), /*#__PURE__*/_jsx(HoverOverlayContainer, {}), /*#__PURE__*/_jsx(TemporaryOverlaysContainer, {}), hasAnyLayoutSections && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LayoutSectionDragLayerContainer, {
          dispatchActionToEventBus: bus.dispatchActionToEventBus
        }), /*#__PURE__*/_jsx(LayoutSectionDropTargetsContainer, {}), /*#__PURE__*/_jsx(LayoutSectionResizeHandleContainer, {}), /*#__PURE__*/_jsx(LayoutSectionDragDomManipulationContainer, {}), /*#__PURE__*/_jsx(LayoutSectionCustomDragLayer, {}), /*#__PURE__*/_jsx(LayoutSectionGridContainer, {}), /*#__PURE__*/_jsx(LayoutSectionSelectedNodeContainer, {}), !shouldUseNopeZonesForAllModules && /*#__PURE__*/_jsx(LayoutSectionNopeZoneContainer, {})]
      }), children]
    })
  );
}
export default UnifiedOverlaysAndToolbarsContainer;